<template>
    <Dialog
            :value="showDialog"
            @input="$emit('input', $event)"
            title="DEFENDER DADOS"
            width="600"
            :show-close-button="true"
    >
        <div class="px-5">
            <m-form ref="formDefesa" @submit.prevent="defenderDados">
                <p class="mb-2 mt-2 text-subtitle-1">Insira abaixo a defesa dos dados:</p>
                <m-text-field
                        class="input-motivo"
                        :rules="[$rules.required]"
                        type="text"
                        v-model="motivo_defesa"
                        placeholder="Explique porque os dados estão corretos"
                        maxlength="600"
                        outlined
                        dense
                />
            </m-form>

            <HintMessage style="max-width: 500px;" title="OBSERVAÇÃO"
                         icon="mdi-lightbulb-on-outline" icon-color="secondary"
                         description='<p>Ao clicar em <strong>“OK”, salvaremos sua defesa</strong>. Para que ela seja <strong>enviada ao Crédito, por favor, clique novamente em “Prosseguir com a Venda”</strong>. Esse processo fará com que a sua defesa seja encaminhada para a análise manual do Credita, podendo levar até 24h para finalização da análise.</p>'
                         :description-html="true"
                         :center-icon="false" />
        </div>

        <v-layout class="justify-end">
            <v-btn large id="ButtonDefender" class="mt-5 btn-defesa" color="primary" @click="defenderDados">
                OK
            </v-btn>
        </v-layout>
    </Dialog>
</template>

<script>
  import { AlertTypes } from '@/plugins/alerts_types'
  import { notification } from '@/plugins/helpers'

  export default {
    name: 'DialogDefenderDados',
    props: {
      value: Boolean,
      idConsulta: [String, Number]
    },
    data: () => ({
      motivo_defesa: ''
    }),
    computed: {
      showDialog: {
        get () { return this.value },
        set (val) { this.$emit('input', val) }
      }
    },
    watch: {
      showDialog (val) {
        if (val) this.motivo_defesa = ''

        if (!val) {
          this.$refs.formDefesa?.resetValidation?.()
          this.motivo_defesa = ''
        }
      }
    },
    methods: {
      fechar () {
        this.$refs.formDefesa?.resetValidation?.()
        this.showDialog = false
      },
      async defenderDados () {
        if (!this.motivo_defesa || this.motivo_defesa.trim() === '') {
          return
        }
        try {
          await this.$http.post('/defender-dados/credito-analise', {
            id_consulta: this.idConsulta,
            motivo_defesa: this.motivo_defesa
          })
          notification(AlertTypes.SUCCESS, 'Defesa salva com sucesso, por favor, prossiga com a venda para enviarmos o motivo ao motor de crédito!')
          this.$emit('defesa-enviada')
          this.fechar()
        } catch (e) {
          notification(AlertTypes.ERROR, 'Erro ao defender os dados!')
        }
      }
    }
  }
</script>

<style scoped>
  .input-motivo {
    margin-top: -1px !important;
  }
  .btn-defesa {
  border-radius: 8px !important;
}
</style>
